"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecentTransactionsCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _constants = require("../../../../constants");
var _state = require("../../../../state");
var _transactions = require("../../transactions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var RecentTransactionsCard = function RecentTransactionsCard(_ref) {
  var transactionsPath = _ref.transactionsPath,
    noData = _ref.noData,
    tableComponent = _ref.tableComponent;
  var _useTransactions = (0, _state.useTransactions)(),
    transactionsState = _useTransactions.transactionsState,
    hasMore = _useTransactions.hasMore,
    fetchTransactions = _useTransactions.fetchTransactions,
    fetchMoreTransactions = _useTransactions.fetchMoreTransactions;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransactionsTable'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    fetchTransactions({
      perPage: _constants.TransactionsPerPage.RECENT
    });
  }, []);
  var loadMore = function loadMore() {
    fetchMoreTransactions({
      perPage: _constants.TransactionsPerPage.RECENT
    });
  };
  var history = (0, _reactRouterDom.useHistory)();
  return /*#__PURE__*/_react.default.createElement(_transactions.TransactionsCard, {
    onViewAll: function onViewAll() {
      history.push(transactionsPath);
    },
    onViewFull: function onViewFull(id) {
      history.push(transactionsPath, {
        search: id
      });
    },
    transactions: transactionsState.data,
    isLoading: transactionsState.loading,
    isCSVLoading: transactionsState.csvLoading,
    loadMore: loadMore,
    hasMore: hasMore,
    title: t('titles.latest'),
    subtitle: t('subtitle.latest'),
    noData: noData,
    tableComponent: tableComponent
  });
};
exports.RecentTransactionsCard = RecentTransactionsCard;